{
  "title": "Sign in",
  "subtitle": "Sign in to your company's workspace.",
  "email": "Email",
  "password": "Password",
  "submit": "Sign in",
  "submitting": "Signing in…",
  "showPassword": "Show password",
  "hidePassword": "Hide password",
  "help": "Forgot your password? Ask your administrator to reset it.",
  "errors": {
    "invalidCredentials": "The email or password is incorrect. Check both and try again.",
    "locked": "Too many failed attempts. This account is locked for a few minutes — try again later.",
    "rateLimited": "Too many sign-in attempts from this network. Wait a minute and try again.",
    "invalidInput": "Enter your email address and password."
  },
  "changePassword": {
    "title": "Change password",
    "subtitle": "Choose a new password for your account.",
    "forcedTitle": "Change your password",
    "forcedNoticeTitle": "Your password was set by an administrator",
    "forcedNotice": "Choose a new password that only you know. Everything else stays locked until you do.",
    "current": "Current password",
    "new": "New password",
    "confirm": "Confirm new password",
    "strengthHint": "At least 10 characters. A few unrelated words make a strong, memorable password.",
    "show": "Show passwords",
    "otherSessions": "You stay signed in here; your other devices and browsers will be signed out.",
    "submit": "Change password",
    "signOut": "Sign out",
    "mismatch": "The passwords don't match. Type the new password again.",
    "currentWrong": "The current password is incorrect.",
    "failed": "The password wasn't changed",
    "done": "Password changed",
    "doneBody": "Your other sessions were signed out."
  },
  "invitation": {
    "title": "Set your password",
    "subtitle": "Welcome, {{name}}. Choose a password to sign in to {{company}}.",
    "checking": "Checking your invitation link…",
    "password": "New password",
    "confirm": "Type it again",
    "expires": "This link works until {{date}}.",
    "submit": "Set password",
    "submitting": "Setting password…",
    "failed": "The password wasn't set",
    "invalidTitle": "This link has expired or was already used",
    "invalidBody": "Invitation links work once, for 3 days. Ask the administrator who invited you to send a new one.",
    "toSignIn": "Go to sign in",
    "doneTitle": "Your password is set",
    "doneBody": "You can now sign in with your e-mail address and the password you just chose.",
    "signIn": "Sign in"
  }
}
